import { render, staticRenderFns } from "./slidebutton.vue?vue&type=template&id=50c67d72&scoped=true&"
import script from "./slidebutton.vue?vue&type=script&lang=js&"
export * from "./slidebutton.vue?vue&type=script&lang=js&"
import style0 from "./slidebutton.vue?vue&type=style&index=0&id=50c67d72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c67d72",
  null
  
)

export default component.exports